import React from "react";
import Loadable from "../../../react-loadable";

const Browser = Loadable({
  loader: () => import("./Browser"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const Upload = Loadable({
  loader: () => import("./upload/index"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const BrowserList = Loadable({
  loader: () => import("./BrowserList"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const At = Loadable({
  loader: () => import("./at/index"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const WordImport = Loadable({
  loader: () => import("./WordImport"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const ImageUpload = Loadable({
  loader: () => import("./ImageUpload"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const VideoUpload = Loadable({
  loader: () => import("./VideoUpload"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const MapLocation = Loadable({
  loader: () => import("./MapLocation"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const FormatAll = Loadable({
  loader: () => import("./FormatAll"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default {
  Browser,
  Upload,
  BrowserList,
  At,
  WordImport,
  ImageUpload,
  VideoUpload,
  MapLocation,
  FormatAll
};



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/plugins/index.js